// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2W1O2","index":"styles_index__3kns8"};